import React, { FC } from 'react';
import schoonCartImg from 'images/schoon-cart.png';
import { useNavigate } from 'react-router-dom';
import { MapPinIcon } from '@heroicons/react/24/solid';
import { AnimateOnScroll } from '../AnimationOnScroll/AnimationOnScroll';

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/services');
  };

  return (
    <div
      className={`nc-SectionHero max-w-7xl min-h-dvh px-10 mx-auto flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-grow lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <AnimateOnScroll>
            <h2 className="font-black text-6xl md:text-7xl xl:text-8xl !leading-[114%] ">
              Welcome to Schoon!
            </h2>
          </AnimateOnScroll>
          <AnimateOnScroll delay={0.2}>
          <span className="text-lg md:text-xl lg:text-2xl text-neutral-500 dark:text-neutral-400">
            Your mobile car wash solution - we bring the shine to you, wherever you are. Experience convenience and quality like never before!
          </span>
          </AnimateOnScroll>
          <button
            className="transform hover:scale-105 transition-transform shadow-lg hover:shadow-xl bg-gradient-to-r from-red-500 to-red-600 px-12 py-6 sm:px-14 sm:py-7 rounded-full text-lg sm:text-xl font-semibold text-white flex items-center space-x-2 hover:from-red-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 duration-500"
            onClick={handleClick}
          >
            <MapPinIcon className={'size-5'}/>
            <span>Find us</span>
          </button>
        </div>
        <AnimateOnScroll
          delay={0.4} variants={{
          hidden: { opacity: 0, x: 20 },
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.8,
              ease: 'easeOut',
              delay: 0.4
            }
          }
        }}
        >
          <div className="relative mb-auto">
            <img
              src={schoonCartImg}
              alt="hero"
            />
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  );
};

export default SectionHero;
